import { IMedia } from "./media";

export enum PropertyType {
  Apartment = "Apartment",
  House = "House",
  Condo = "Condo",
  Land = "Land",
  Commercial = "Commercial",
  Townhouse = "Townhouse",
  Duplex = "Duplex",
  Bungalow = "Bungalow",
  Studio = "Studio",
  Penthouse = "Penthouse",
  Farm = "Farm",
  Warehouse = "Warehouse",
  OfficeSpace = "Office Space",
  Retail = "Retail",
  Industrial = "Industrial",
  MixedUse = "Mixed Use",
  Hotel = "Hotel",
  Resort = "Resort",
  Villa = "Villa",
  Cabin = "Cabin",
  ManufacturedHome = "Manufactured Home",
  ParkingSpace = "Parking Space",
}
export enum Status {
  DRAFT = "draft",
  PUBLISHED = "published",
  ARCHIVED = "archived",
}

export interface IProperties {
  _id?: string;
  name: string;
  propertyType: PropertyType;
  description: string;
  totalgarage: number;
  yearbuilt: string;
  totalbedrooms: number;
  totalbathrooms: number;
  squaremeter: number;
  facilities: string[];
  address: string;
  state: string;
  city?: string;
  landmark: string;
  zipcode: number;
  media: Partial<IMedia>[] | string[];
  documents: Partial<IMedia>[] | string[];
  createdBy: string;
  isActive: boolean;
  coordinate: {
    lat: number;
    lng: number;
  };
  status: Status;
  location?: string;
}

export type propFilter={
  location:string,
  propertyType:string,
  priceRange:string,
  status:string,
  sort:string,
  isSearch:boolean,
  propertyName:string
}